<template>
  <!-- <div class="the-navbar__user-meta flex items-center"> -->
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer profilecss" id="profile_dropdown">
      <div style="display:flex; align-items: center;">
        <div class="text-right leading-tight">
          <p class="font-semibold">{{ activeUserInfo.name }}</p>
          <!-- <small>Available</small> -->
        </div>
        <feather-icon icon="CornerDownLeftIcon" class="sm:ml-3 ml-2" />
      </div>
      

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="$router.push('/profile').catch(() => {})">
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Profile</span>
            </li>

            <!-- <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="$router.push('/apps/email').catch(() => {})">
              <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Inbox</span>
            </li>

            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="$router.push('/apps/todo').catch(() => {})">
              <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Tasks</span>
            </li>

            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="$router.push('/apps/chat').catch(() => {})">
              <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Chat</span>
            </li>

            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="$router.push('/apps/eCommerce/wish-list').catch(() => {})">
              <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Wish List</span>
            </li> -->

            <vs-divider class="m-1" />

            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="logout">
              <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Logout</span>
            </li>
          </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  <!-- </div> -->
  

</template>

<script>
// import firebase from 'firebase/app'
// import 'firebase/auth'

export default {
  data () {
    return {

    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    logout () {

      // if user is logged in via auth0
      // if (this.$auth.profile) this.$auth.logOut()

      // if user is logged in via firebase
      // const firebaseCurrentUser = firebase.auth().currentUser

      // if (firebaseCurrentUser) {
      //   firebase.auth().signOut().then(() => {
      //     this.$router.push('/pages/login').catch(() => {})
      //   })
      // }
      // If JWT login
      // if (localStorage.getItem('accessToken')) {
        sessionStorage.removeItem('accessToken')
        // this.$router.push('/pages/login').catch(() => {})
      // }

      // Change role on logout. Same value as initialRole of acj.js
      // this.$acl.change('admin')
      sessionStorage.removeItem('userInfo')
      sessionStorage.removeItem('loan_info')
      console.log('halo there logout')
      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/pages/login').catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.profilecss{
  &:hover{
    background:#D5D5D5;
  }
}

</style>
